import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface PendingStory {
  jobId: number;
  themeId: string;
  themeName: string;
  languageCode: string;
  submittedAt: string;
}

interface PendingStoriesState {
  pending: PendingStory[];
  addPending: (story: PendingStory) => void;
  removePending: (jobId: number) => void;
  getPending: (jobId: number) => PendingStory | undefined;
  clearCompleted: () => void;
}

export const usePendingStories = create<PendingStoriesState>()(
  persist(
    (set, get) => ({
      pending: [],

      addPending: (story) =>
        set((state) => ({
          pending: [...state.pending, story],
        })),

      removePending: (jobId) =>
        set((state) => ({
          pending: state.pending.filter((s) => s.jobId !== jobId),
        })),

      getPending: (jobId) => {
        const state = get();
        return state.pending.find((s) => s.jobId === jobId);
      },

      clearCompleted: () =>
        set((state) => ({
          // Keep only jobs from last 24 hours
          pending: state.pending.filter((s) => {
            const age = Date.now() - new Date(s.submittedAt).getTime();
            return age < 24 * 60 * 60 * 1000; // 24 hours
          }),
        })),
    }),
    {
      name: 'pending-stories',
    }
  )
);
